// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"385":"80e9d3e3","488":"96916010","911":"57ef3730"}[chunkId] + ".chunk.js";
};